"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const Button_1 = require("@Components/Buttons/Button");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const GoBackModal = (props) => {
    const { individualWorkModalIsOpen, closeIndividualWorkModal, backLink } = props;
    return (react_1.default.createElement(ModalPortal_1.default, { isOpen: individualWorkModalIsOpen, onClose: closeIndividualWorkModal },
        react_1.default.createElement(Popup_1.default, { onClose: closeIndividualWorkModal, className: 'back-confirmation' },
            react_1.default.createElement("div", { className: 'info-head' },
                react_1.default.createElement("h3", null, "Are you sure you want to go back?"),
                react_1.default.createElement("p", null, "You will lose any unsaved changes.")),
            react_1.default.createElement("div", { className: "search-confirm-popup-content" },
                react_1.default.createElement("div", { className: 'buttons-block' },
                    react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'secondary', onClick: closeIndividualWorkModal }, "No"),
                    react_1.default.createElement(Button_1.Button, { mainColor: true, className: 'back', type: 'primary', linkOnClick: closeIndividualWorkModal, typeLink: !!backLink, linkTo: backLink }, "Yes, take me back"))))));
};
exports.default = GoBackModal;
